import React, { useState } from 'react'
import Header from '../_components/common/Header'
import '../_css/Settings.css'
import SettingsUI from '../_components/UI/SettingsUI';
import SettingsNotifyUI from '../_components/UI/SettingsNotifyUI';
import SubscriptionInfo from '../_components/UI/SubscriptionInfo';

const Settings = () => {
     const [menu, setMenu] = useState("profile");
  return (
    <div className='page-main'>
        <Header name = {["Settings"]}/>

         <div className="tm-main">
      <div className="settings-tog-con">
        <div
          onClick={() => setMenu("profile")}
          className="settings-tog pe-cursor"
          style={{
            backgroundColor: menu == "profile" && "#FFFFFF",
            color: menu == "profile" && "#030712",
          }}
        >
          Profile
        </div>
        <div
          className="settings-tog pe-cursor"
          onClick={() => setMenu("notify")}
          style={{
            backgroundColor: menu == "notify" && "#FFFFFF",
            color: menu == "notify" && "#030712",
          }}
        >
          Notifications
        </div>
      </div>

      {menu == 'profile' && (
        <div className="settings-profile-layout">
          <SettingsUI />
          <SubscriptionInfo />
        </div>
      )}
      {menu == 'notify' && <SettingsNotifyUI />}
    </div>

        
    </div>
  )
}

export default Settings